var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "seo-peergroups" } },
    [
      _c(
        "portal",
        { attrs: { to: "ads-container-top" } },
        [
          _c("ci-suggested-external-content", {
            attrs: {
              type: "display",
              id: _vm.adIds.header,
              sticky: false,
              easeOut: false,
            },
          }),
        ],
        1
      ),
      _c(
        "portal",
        { attrs: { to: "ads-container-right" } },
        [
          _c("ci-suggested-external-content", {
            attrs: {
              type: "skyscraper",
              id: _vm.adIds.skyscraper,
              sticky: false,
            },
          }),
          _c("ci-suggested-external-content", {
            attrs: {
              type: "sidebar",
              id: _vm.adIds.sidebar_2nd,
              sticky: false,
            },
          }),
        ],
        1
      ),
      _c("portal", { attrs: { to: "content-header" } }, [
        _c(
          "div",
          {
            key: "peergroup-header",
            staticClass: "ci-content-header",
            attrs: { id: "peergroup-header" },
          },
          [
            _c("div", { staticClass: "ci-content-header__inner" }, [
              _c("h1", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ui.views.products.seo.peergroups.index.title",
                    expression:
                      "'ui.views.products.seo.peergroups.index.title'",
                  },
                ],
                staticClass: "mb-2",
              }),
              _c("div", {
                staticClass: "seo-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("ui.views.products.seo.peergroups.index.text_html")
                  ),
                },
              }),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "ci-card p-4 text-center" },
        [
          _c("h2", {
            staticClass: "h5 mb-0",
            domProps: {
              textContent: _vm._s(
                _vm.$t(
                  "ui.views.products.seo.peergroups.index.search_suggestions"
                )
              ),
            },
          }),
          _c("ci-peergroup-list", {
            staticClass: "my-4",
            attrs: {
              target: "ranking",
              "click-callback": _vm.handlePeergroupInput,
            },
          }),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "ui.views.products.seo.peergroups.index.select_peergroup_html"
                )
              ),
            },
          }),
          _c(
            "ci-fe-wrapper",
            {
              staticClass: "mt-4",
              attrs: {
                label: _vm.$t(
                  "ui.views.products.seo.peergroups.index.searchbar.peergroup.label"
                ),
                "leading-icon": "mdi-magnify",
                hint: true,
              },
            },
            [
              _c("v-select", {
                staticClass: "ci-form--input",
                attrs: {
                  id: "peergroup-select",
                  options: _vm.peergroups,
                  label: "name",
                  "data-cy": "peergroup",
                },
                on: { input: _vm.handlePeergroupInput },
                scopedSlots: _vm._u([
                  {
                    key: "open-indicator",
                    fn: function ({ attributes }) {
                      return [
                        _c(
                          "span",
                          _vm._b(
                            { staticClass: "mdi mdi-chevron-down text-lg" },
                            "span",
                            attributes,
                            false
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }